import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { FormGroup, FormControlName } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ViewEncapsulation } from '@angular/compiler/src/core';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'clickatell-select',
  templateUrl: './clickatell-select.component.html',
  styleUrls: ['./clickatell-select.component.scss'],
})
export class ClickatellSelectComponent implements OnChanges {
  selectvalue;
  data$: Observable<string[]>;

  @Input()
  form: FormGroup;
  @Input()
  formName: FormControlName;
  @Input()
  selected: string;
  @Input()
  data: Observable<string[]>;
  @Input()
  defaultValue: string;
  @Input()
  name: string;

  @Input()
  disabled?: boolean;

  @Output()
  valueChange = new EventEmitter<string>();

  @Output()
  focus = new EventEmitter();

  @Input()
  get value() {
    return this.selectvalue;
  }

  set value(val) {
    this.selectvalue = val;
    this.selected = val;
    this.valueChange.emit(val);
  }

  ngOnChanges(change: SimpleChanges): void {
    if (change.data && this.data) {
      this.data.pipe(
        map((dataArray) => {
          if (!dataArray.includes(this.defaultValue)) {
            dataArray.unshift(this.defaultValue);
          }
          return dataArray;
        })
      );
    }
  }

  onChange(event) {
    this.selected = event;
    this.valueChange.emit(event);
  }

  onfocus(element: MatSelect) {
    this.data$ = this.data;
    const focusElement = {
      name: this.name,
      element: element,
    };

    this.focus.emit(focusElement);
  }

  setOption(value) {
    return typeof value === 'object' && value.flowName ? value.flowName : value;
  }
}
